<template>
  <v-dialog v-model="localDialog" width="35%" @update:modelValue="updateDialog" transition="" persistent :open-delay="0" :close-delay="0">
    <v-card>
        <v-card-title class="text-h6">
            <span>{{ isEntryMode ? 'Add Product Type' : 'Update Product Type' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-form @submit.prevent="submit" ref="ProductTypeSetup">
              <v-row>
                  <v-col cols="12"> 
                      <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="name.value.value"
                          :error-messages="name.errorMessage.value"
                          clearable
                      >
                        <template #label>
                          Name <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-autocomplete
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="type_id.value.value"
                        :error-messages="type_id.errorMessage.value"
                        clearable
                        :items="getProductTypeList"
                        :item-title="item => `${item.code} - ${item.name}`"   
                        autocomplete="off"                                               
                        item-value="id"
                      >
                        <template #label>
                            Product Type <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="category_id.value.value"
                        :error-messages="category_id.errorMessage.value"
                        clearable
                        :items="getCategoryList"
                        :item-title="item => `${item.code} - ${item.name}`"  
                        autocomplete="off"                                               
                        item-value="id"
                      >
                        <template #label>
                            Category <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="unit_id.value.value"
                        :error-messages="unit_id.errorMessage.value"
                        clearable
                        :items="getUnitList"
                        :item-title="item => `${item.code} - ${item.name}`"  
                        autocomplete="off"                                               
                        item-value="id"
                      >
                        <template #label>
                          Unit <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>
                      
                  </v-col>
              </v-row>

              <v-divider></v-divider>
              <v-card-actions>
                  <v-layout class="justify-end">
                      <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                        <v-btn 
                        class="bg-brand w-15 ms-2"
                        variant="flat" 
                        type="submit"
                        >
                        {{ isEntryMode ? 'Save' : 'Update' }}
                        </v-btn>
                  </v-layout>
              </v-card-actions>
            </v-form>
        </v-card-text>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'
import { fileServerUrl, getCategoryList, getUnitList } from "@/store/api";

export default {
  name: 'Product Type Setup',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        name: '',
        category_id: null,
        type_id: null,
        unit_id: null,
        status: true
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: '',
      loading: false,
      isEntryMode: true,
    }
  },
  computed: {
    getUnitList() {
      return this.$store.getters.getUnitList;
    },
    getProductTypeList() {
      return this.$store.getters.getProductTypeList;
    },
    getCategoryList() {
      return this.$store.getters.getCategoryList;
    }
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.name.setValue(newData.name || '', false);
        this.category_id.setValue(newData.category_id || null, false);
        this.type_id.setValue(newData.type_id || null, false);
        this.unit_id.setValue(newData.unit_id || null, false);
        this.status.setValue(newData.status || true, false);
      },
    }
    
  },
  created() {
    if (this.$store.getters.getUnitList.length === 0) {
      this.$store.dispatch("getUnitList");
    }
    if (this.$store.getters.getProductTypeList.length === 0) {
      this.$store.dispatch("getProductTypeList");
    }
    if (this.$store.getters.getCategoryList.length === 0) {
      this.$store.dispatch("getCategoryList");
    }
  },
  methods: {
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.$emit('update:dialog', false);
    },
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
        validationSchema: yup.object({
        }),
    });

    const name = useField('name');
    const category_id = useField('category_id');
    const type_id = useField('type_id');
    const unit_id = useField('unit_id');
    const status = useField('status');
    const errorMessages = ref('');
    const loading  = ref('');
    const store = useStore();

    const submit = handleSubmit((values) => {
        values.status = true;
        store.dispatch("saveUpdateProduct", values)
            .then((response) => {
                resetForm();
                emit('update:dialog', false);
                toast.success(response.data.message);
                loading.value = true;
                store.dispatch('getProductMapList')
                    .then(data => {
                        loading.value = false;
                    })
                    .catch(error => {
                        loading.value = false;
                        toast.error(error.response.data.message);
                    })
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
      submit,
      name,
      category_id,
      type_id,
      unit_id,
      status,
      errorMessages,
      resetForm,
      loading
    }
  },
  mounted() {
  }
}
</script>

